/**
 * @file コンポーネント：フル動画ページ機器広告コンテンツ DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { ModalAdConfirm } from "~/src/components/projects/Video/ModalAdConfirm";
import { ModalAdFailure } from "~/src/components/projects/Video/ModalAdFailure";
import { ModalAdSuccess } from "~/src/components/projects/Video/ModalAdSuccess";
import { PopupAd } from "~/src/components/projects/Video/PopupAd";

// スタイル読み込み
import { StyledContents } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <>
            {props.adOperationButtonText !== null && (
                <StyledContents>
                    <PopupAd
                        isOpenPopupAd={props.isOpenPopupAd}
                        languageCodeOperation={props.languageCodeOperation}
                        operationId={props.operationId}
                        setIsOpenModalAdConfirm={props.setIsOpenModalAdConfirm}
                        setIsOpenPopupAd={props.setIsOpenPopupAd}
                    />
                    <ModalAdConfirm
                        adOperationId={props.adOperationId}
                        isOpenModalAdConfirm={props.isOpenModalAdConfirm}
                        operationId={props.operationId}
                        setIsOpenModalAdConfirm={props.setIsOpenModalAdConfirm}
                        setIsOpenModalAdFailure={props.setIsOpenModalAdFailure}
                        setIsOpenModalAdSuccess={props.setIsOpenModalAdSuccess}
                        setIsOpenPopupAd={props.setIsOpenPopupAd}
                    />
                    <ModalAdFailure
                        isOpenModalAdConfirm={props.isOpenModalAdConfirm}
                        isOpenModalAdFailure={props.isOpenModalAdFailure}
                        setIsOpenModalAdConfirm={props.setIsOpenModalAdConfirm}
                        setIsOpenModalAdFailure={props.setIsOpenModalAdFailure}
                    />
                    <ModalAdSuccess
                        isOpenModalAdSuccess={props.isOpenModalAdSuccess}
                        setIsOpenModalAdSuccess={props.setIsOpenModalAdSuccess}
                    />
                </StyledContents>
            )}
        </>
    );
};
